import React, { useState, useContext, Fragment, useEffect } from "react";
import Traductor from "./Traductor";

function PopupAlertLegalPersonalData({ CloseModalAlert }) {
  const t = new Traductor();

  const [ModalAlert, setModalAlerts] = useState(false);
  return (
    <div
      className="c-modal c-modal--left c-modal--advanced-filters c-vehicle-filters--advanced"
      id="demo-modal"
    >
      <div className="c-modal__overlay  js-modal-close" tabIndex="-1"></div>
      <div className="c-modal__wrapper" role="dialog">
        <header className="c-modal__header">
          <div className="c-modal__title__wrapper">
            <p className="u-h4 c-modal__title">Aviso legal Rema Mobile</p>
          </div>
          <button
            className="c-modal__close-btn  js-modal-close"
            onClick={CloseModalAlert}
            type="button"
            aria-label="Cerrar modal."
          ></button>
        </header>
        <div className="c-modal__content" role="document">
          <div
            className="c-accordion  js-accordion  js-is-fx"
            data-accordion-multiple="true"
          >
            <p>
              En cumplimiento de la Ley Orgánica 15/1999, de 13 de Diciembre de
              Protección de Datos de Carácter Personal, Ud. queda informado y
              consiente que los datos personales suministrados en el presente
              formulario y los que suministre en el futuro, serán incorporados a
              un fichero automatizado titularidad de Volkswagen Bank GmbH, S.E.
              /VOLKSWAGEN RENTING S.A. (si el/los aplicativo/-s a utilizar
              es/son “Calculadora Financiera”, “REMA”, “Contact Platform”,
              “Valores Residuales y Provisiones”, “Credit Corporate”, “Gavis”
              y/o “Registros de Calidad” “FSMobility”)/ VOLKSWAGEN BANK GmbH,
              S.E. (si el aplicativo a utilizar es “Control de Stock”)/,
              VOLKSWAGEN INSURANCE SERVICES, CORREDURÍA DE SEGUROS S.L. (si
              el/los aplicativo/-s a utilizar es/son “Teide”y/o “Carrier”),para
              ser tratados con la finalidad de gestionar su solicitud de acceso
              a dicho/-s aplicativo/-s así como para el envío de información por
              medios de comunicación electrónica relacionados con el mismo.
            </p>
            <br></br>
            <p>
              Si Ud. forma parte de la Red oficial de Ventas de las marcas del
              Grupo Volkswagen, queda informado y consiente que sus datos
              personales sean tratados por las entidades citadas en el párrafo
              precedente, con la finalidad de gestionar la tramitación de
              operaciones, solicitudes de las mismas y contratos, realización de
              encuestas de opinión, estudios estadísticos, participación en
              promociones y campañas de incentivos y el envío de informaciones
              comerciales, propias o de terceros (cuyas actividades se
              relacionan con los sectores indicados a continuación), por
              cualquier medio y en particular por medios de comunicación
              electrónica, pudiendo ser tales informaciones de carácter general
              o adecuados a sus perfiles particulares.
            </p>
            <br></br>
            <p>
              Además, Ud. consiente que sus datos sean cedidos a las empresas
              del Grupo Volkswagen, dentro de la Unión Europea, cuyas
              actividades se relacionan con los sectores de automoción, alquiler
              de vehículos, financiero, asegurador y de mediación de seguros,
              para su utilización con las mismas finalidades indicadas
              anteriormente.
            </p>
            <br></br>
            <p>
              Si no desea recibir las informaciones anteriormente referidas y/o
              ceder sus datos en los términos señalados, puede contactar con
              nosotros enviándonos un mail a sistemasvwis@vwfs.com o por correo
              postal a Avda. Baix LLobregat, Nº 8, 1ª Planta, Parque de Negocios
              Mas Blau II, 08820 El Prat de Llobregat (Barcelona).
            </p>
            <br></br>
            <br></br>
            <p>
              El responsable del fichero es VOLKSWAGEN BANK GmbH, S.E./
              VOLKSWAGEN RENTING S.A. (Avda. de Bruselas, 34, Alcobendas
              –Madrid- 28108)/ VOLKSWAGEN INSURANCE SERVICES, CORREDURÍA DE
              SEGUROS S.L. (Avda. Baix Llobregat, nº 8, 1ª pl., Parque de
              Negocios Mas Blau II, El Prat de Llobregat –Barcelona-)
              dependiendo del aplicativo en el que Ud. esté dado de alta y ante
              quien/-es se pueden ejercitar los derechos de acceso,
              rectificación, cancelación y oposición en la forma y condiciones
              que la normativa de protección de datos establezca en cada
              momento.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PopupAlertLegalPersonalData;
